import {home} from './module/home';
import {laureates} from './module/laureates';
import {donors} from './module/donors';
import {nomination} from './module/nomination';
import {news} from './module/news';
import {activity} from './module/activity';
import {about} from './module/about';
import {prizeweek} from './module/prizeweek';
import {detail} from './module/detail';
const routes=[
    ...home,
    ...laureates,
    ...donors,
    ...nomination,
    ...news,
    ...activity,
    ...about,
    ...prizeweek,
    ...detail
]

export default routes